import {Frontend} from "./frontend";

(function () {
    XonBoard.SensorAttributeRenderers = {
        match(rows, test) {
            const numeric = value => value !== '' && value !== null && !isNaN(value);
            const compare = (left, operator, right) => {
                if (numeric(left) && numeric(right)) {
                    left = Number(left);
                    right = Number(right);
                }

                switch (operator) {
                    case '>': return left > right;
                    case '>=': return left >= right;
                    case '<': return left < right;
                    case '<=': return left <= right;
                    case '==': return left == right;
                    case '!=': return left != right;
                    default: return false;
                }
            };

            const ordered = [...rows].sort((row1, row2) => row1.sort - row2.sort);
            const index = ordered.findIndex(rule => (rule.value ?? '') !== '' && compare(test, rule.operator, rule.value));

            return index === -1 ? null : {index, rule: ordered[index]};
        },
        list: {

            selectors: {
                sensor_attribute_renderers_table: $('#sensor-attribute-renderers-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sensor_attribute_renderers_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_attribute_renderers_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {
                            className: 'dt-control',
                            orderable: false,
                            data: null,
                            defaultContent: '<i class="fa fa-angle-right renderer-chevron" aria-hidden="true"></i>'
                        },
                        {data: 'name', name: 'sensor_attribute_renderers.name', render: name => name || '<span class="text-grey5">&mdash;</span>'},
                        {data: 'attribute_name', name: 'sensor_attribute_renderers.attribute_name'},
                        {data: 'comparators_count', name: 'sensor_attribute_renderers.comparators_count'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[1, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                const $table = this.selectors.sensor_attribute_renderers_table;

                const symbols = {'>': '>', '>=': '≥', '<': '<', '<=': '≤', '==': '=', '!=': '≠'};
                const escape = value => $('<div>').text(value ?? '').html();

                function format(record) {
                    const comparators = [...(record.comparators ?? [])].sort((comp1, comp2) => comp1.sort - comp2.sort);

                    if (!comparators.length) {
                        return `<div class="renderer-rules"><ol class="renderer-rule-list"><li class="text-grey5">${$table.data('empty-label')}</li></ol></div>`;
                    }

                    const rules = comparators.map((comparator, index) => `<li>
                        <span class="renderer-rule-list__num">${index + 1}</span>
                        <span class="text-grey5">${$table.data('if-label')}</span>
                        <code>${escape(record.attribute_name)}</code>
                        <strong>${symbols[comparator.operator] ?? escape(comparator.operator)}</strong>
                        <strong class="tabular-nums">${escape(comparator.value)}</strong>
                        <i class="fa fa-right-long text-grey5" aria-hidden="true"></i>
                        <span class="renderer-chip renderer-chip--${escape(comparator.color)}">${escape(comparator.rendering_value)}</span>
                    </li>`).join('');

                    return `<div class="renderer-rules"><ol class="renderer-rule-list">${rules}<li class="renderer-rule-list__otherwise">${$table.data('otherwise-label')}</li></ol></div>`;
                }

                $table.find('tbody').on('click', 'tr', function (event) {
                    if ($(event.target).closest('a, button, .row-menu, .dropdown-menu').length) {
                        return;
                    }

                    const tr = $(this);
                    const row = table.row(tr);

                    if (!row.data()) {
                        return;
                    }

                    if (row.child.isShown()) {
                        tr.removeClass('shown');
                        $(row.child()).find('.renderer-rules').slideUp(150, () => row.child.hide());
                    } else {
                        row.child(format(row.data()), 'renderer-rules-row').show();
                        tr.addClass('shown');
                        $(row.child()).find('.renderer-rules').hide().slideDown(150);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                XonBoard.Utils.Select2.init();
                this.addHandlers(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
